import { apiClient } from "@/api/client";
import { endpoints } from "@/api/endpoints";
import type { ApiResponse } from "@/api/types";

export type NotificationKind =
  | "TASK_ASSIGNED" | "TASK_VERSION_SUBMITTED" | "TASK_REVIEWED"
  | "TASK_REMINDER" | "TASK_ESCALATED" | "TASK_DEADLINE_MISSED";

export interface NotificationDto {
  notification_id: string;
  kind: NotificationKind;
  title: string;
  body: string | null;
  entity: string | null;
  entity_id: string | null;
  link: string | null;
  actor_user_id: string | null;
  read_on: string | null;
  created_on: string;
}

const E = endpoints.notifications;

export const notificationsService = {
  async inbox(unreadOnly = false, limit = 30): Promise<{ items: NotificationDto[]; unread: number }> {
    const { data } = await apiClient.get<ApiResponse<{ items: NotificationDto[]; unread: number }>>(E.root, { params: { unreadOnly, limit } });
    return data.data;
  },
  async unreadCount(): Promise<{ unread: number }> {
    const { data } = await apiClient.get<ApiResponse<{ unread: number }>>(E.unreadCount);
    return data.data;
  },
  /** Absent ids = mark everything read. */
  async markRead(ids?: string[]): Promise<{ marked: number }> {
    const { data } = await apiClient.post<ApiResponse<{ marked: number }>>(E.read, ids ? { ids } : {});
    return data.data;
  },
};

export const KIND_LABEL: Record<NotificationKind, string> = {
  TASK_ASSIGNED: "Assigned",
  TASK_VERSION_SUBMITTED: "For review",
  TASK_REVIEWED: "Reviewed",
  TASK_REMINDER: "Reminder",
  TASK_ESCALATED: "Escalated",
  TASK_DEADLINE_MISSED: "Missed",
};

export const KIND_TONE: Record<NotificationKind, string> = {
  TASK_ASSIGNED: "bg-blue-100 text-blue-800",
  TASK_VERSION_SUBMITTED: "bg-purple-100 text-purple-800",
  TASK_REVIEWED: "bg-green-100 text-green-800",
  TASK_REMINDER: "bg-amber-100 text-amber-800",
  TASK_ESCALATED: "bg-red-100 text-red-800",
  TASK_DEADLINE_MISSED: "bg-red-100 text-red-800",
};
